import { consola } from 'consola'
import { defineNuxtPlugin } from 'nuxt/app'

export default defineNuxtPlugin({
  name: 'auth-loader:plugin',
  dependsOn: ['alt-container:plugin', 'host-loader:plugin'],
  async setup() {
    if (import.meta.client) return

    const { service } = useAuth()
    const token = service.getToken()

    if (!token) {
      return
    }

    try {
      await service.signIn(token)
    } catch (e) {
      service.signOut()
      consola.error(e)
    }
  },
})
